export const features = {
  3000: 'furnished',
  3013: 'elevator',
  3014: 'heating',
  3002: 'air',
  3015: 'kitchen',
  3016: 'balcony',
  3017: 'reception',
  3018: 'pool',
  3019: 'parking',
  3020: 'pets-allowed',
  3021: 'smoking-true',
  3009: 'washing-machine',
  3010: 'dryer',
  3008: 'dishwasher',
  3100: 'oven',
  3007: 'tv',
  3011: 'interior-house',
  3012: 'exterior-house',
  3023: 'handicap-accesible',
  3026: 'water',
  3027: 'heating',
  3028: 'dryer',
  4000: 'furnished',
  4001: 'air',
  4002: 'heating',
  4003: 'bathroom',
  4004: 'desktop',
  4005: 'balcony',
  4006: 'tv',
  4007: 'exterior-house',
  4008: 'exterior-house',
  4009: 'chest',
  4010: 'shelving',
  4100: 'mini-storage',
  4101: 'home-key',
  4102: 'shelving',
  4103: 'shelving',
  4104: 'window',
  4105: 'window-view-street',
  4106: 'window-view-pedestrian-street',
  4107: 'window-view courtyard',
  4108: 'window-view-interior-patio',
  4109: 'couples-allowed'
};

export const billsIncluded = {
  5000: 'electricity',
  5001: 'water',
  5002: 'gas',
  5003: 'wifi',
  5004: 'meal-service',
  5005: 'cleaning-service',
  5006: 'heating',
  5007: 'council-tax',
  5008: 'bed-linen'
};
